"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureDependencyNames = getFeatureDependencyNames;
var _features = require("./features");
function getFeatureDependencyNames(feature) {
  switch (feature) {
    case _features.FEATURE_NAMES.ajax:
      return [_features.FEATURE_NAMES.jserrors];
    case _features.FEATURE_NAMES.sessionTrace:
      return [_features.FEATURE_NAMES.ajax, _features.FEATURE_NAMES.pageViewEvent];
    case _features.FEATURE_NAMES.sessionReplay:
      return [_features.FEATURE_NAMES.sessionTrace];
    case _features.FEATURE_NAMES.pageViewTiming:
      return [_features.FEATURE_NAMES.pageViewEvent];
    // this could change if we disconnect window load timings
    default:
      return [];
  }
}